import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';
import Select from 'react-select'

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../helpers/message.js";
import { formateDateApi, formateDate, formateDateandTime } from "../../helpers/formats.js";

// api
import concessionaria_api from "../../api/concessionaria_api.js";
import boletimvistoria_api from "../../api/boletimvistoria_api.js";
import formulariovistoria_api from "../../api/formulariovistoria_api.js";

// views
import VistoriaFicha from "../Shared/VistoriaFicha";

export default function ConsultaVistoriaLista({ history }) {

    const { register, handleSubmit, errors, getValues, setValue } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = useState(false);

    const [list_table, set_list_table] = useState([]);
    const [rowView, set_rowView] = useState(null);
    const [showDetail, set_showDetail] = useState(false);

    // Concessionária
    const [options_concessionaria, set_options_concessionaria] = useState([]);
    const loadOptionsConcessionarias = () => {
        concessionaria_api.getByUsuarioId().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                set_options_concessionaria(result.data);
            }
        })
    }

    const [concessionaria, set_concessionaria] = useState(null);
    const handleChangeConcessionaria = (value) => {
        set_concessionaria(value);
        setValue("concessionaria", value, true);
    }

    // Situação Análise
    const options_situacaoAnalise = [
        { value: "", label: "Todas" },
        { value: "Finalizado sem Inconformidades", label: "Finalizado sem Inconformidades" },
        { value: "Penalidades Apontadas", label: "Penalidades Apontadas" },
        { value: "Aguardando Defesa", label: "Aguardando Defesa" },
        { value: "Em Análise de Defesa", label: "Em Análise de Defesa" },
        { value: "Defesa Aprovada", label: "Defesa Aprovada" },
        { value: "Aguardando Publicação", label: "Aguardando Publicação" },
        { value: "Defesa Reprovada e Advertido", label: "Defesa Reprovada e Advertido" },
        { value: "Defesa Reprovada e Multado", label: "Defesa Reprovada e Multado" },
        { value: "Em Análise de Recurso", label: "Em Análise de Recurso" },
        { value: "Finalizado com Penalidade", label: "Finalizado com Penalidade" },
        { value: "Arquivado", label: "Arquivado" },
        { value: "Aguardando Análise", label: "Aguardando Análise" }
    ];

    const [situacaoAnalise, set_situacaoAnalise] = useState(null);
    const handleChangeSituacaoAnalise = (value) => {
        set_situacaoAnalise(value);
        setValue("situacaoAnalise", value, true);
    }

    const [formularioAnalise, set_formularioAnalise] = useState(null);
    const handleChangeFormulario = (value) => {
        set_formularioAnalise(value);
        setValue("formularioAnalise", value, true);
    }

    const [options_formularios, setOptions_formularios] = useState([]);
    const handleFormularios = () => {
        setshowLoading(true);
        formulariovistoria_api.getAll().then((result) => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                setOptions_formularios(result.data);
            }
        });
    }

    const handleView = (rowData) => {
        setshowLoading(true);
        boletimvistoria_api.getItem(rowData.boletimVistoria_Id).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_rowView(result.data);
                set_showDetail(true);
            }
        });

    }

    const handleReturn = () => {
        set_showDetail(false);

        set_rowView(null);

        let data = getValues();
        loadList(data);
    }

    const loadList = (data) => {
        let json_submit = {
            inicio: formateDateApi(data.dataInicial),
            fim: formateDateApi(data.dataFinal),
            concessionaria_Id: concessionaria ? concessionaria.concessionaria_Id : null,
            situacaoAnalise: situacaoAnalise ? situacaoAnalise.value : "",
            formularioVistoria_Id: formularioAnalise ? formularioAnalise.formularioVistoria_Id : null
        }

        setshowLoading(true);
        boletimvistoria_api.postByFilter(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_list_table(result.data);
            }
        });
    }

    const onSubmit = (data) => {
        loadList(data);
    }

    useEffect(() => {
        loadOptionsConcessionarias();
        handleFormularios();
    }, []);

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className={showDetail ? "d-none" : "content"}>
                <Row>
                    <Col md="12">
                        <Card className="mt-4">
                            <CardHeader>
                                <h4 className="titleCard">Consulta de Vistorias</h4>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <Row className="mb-4 align-items-end">
                                        <Col lg="4" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Data vistoria inicial</label>
                                                <Input className="form-control"
                                                    autocomplete="off"
                                                    type="date"
                                                    name="dataInicial"
                                                    innerRef={register({ required: true })}
                                                />
                                                {errors.dataInicial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Data vistoria final</label>
                                                <Input className="form-control"
                                                    autocomplete="off"
                                                    type="date"
                                                    name="dataFinal"
                                                    innerRef={register({ required: true })}
                                                />
                                                {errors.dataFinal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                            </FormGroup>
                                        </Col>
                                        <Col lg="4" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Concessionária</label>
                                                <Select
                                                    name="concessionaria"
                                                    options={options_concessionaria}
                                                    getOptionLabel={o => o.identificacao}
                                                    getOptionValue={o => o.concessionaria_Id}
                                                    value={concessionaria}
                                                    onChange={(o) => handleChangeConcessionaria(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "concessionaria" },
                                                        { required: false })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="6" md="6" sm="12">
                                            <FormGroup>
                                                <label className="form-control-label">Situação Análise</label>
                                                <Select
                                                    name="situacaoAnalise"
                                                    options={options_situacaoAnalise}
                                                    getOptionLabel={o => o.label}
                                                    getOptionValue={o => o.value}
                                                    value={situacaoAnalise}
                                                    onChange={(o) => handleChangeSituacaoAnalise(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "situacaoAnalise" },
                                                        { required: false })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg={6} md={6} sm={12}>
                                            <FormGroup>
                                                <label className="form-control-label">Formulário</label>
                                                <Select
                                                    name="formularioAnalise"
                                                    options={options_formularios}
                                                    getOptionLabel={o => o.identificacao}
                                                    getOptionValue={o => o.formularioVistoria_Id}
                                                    value={formularioAnalise}
                                                    onChange={(o) => handleChangeFormulario(o)}
                                                    classNamePrefix="select"
                                                    placeholder="[ Selecione ]"
                                                    ref={e => register(
                                                        { name: "formularioAnalise" },
                                                        { required: false })
                                                    }
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col lg="12" md="12" sm="12" className="text-center">
                                            <Button color="info" type="submit"><i className="fas fa-search"></i> Pesquisar</Button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col lg="12" md="12" sm="12">
                                            <MaterialTable style={{ minHeight: "auto" }}
                                                title="Resultado da Pesquisa"
                                                columns={[
                                                    { title: '', render: (rowData) => (<i className={"fas fa-circle " + (rowData.semaforoProximaAcao == 'Vermelho' ? "text-danger" : (rowData.semaforoProximaAcao == "Amarelo" ? "text-warning" : "text-success"))}></i>) },
                                                    { title: 'Número do Boletim', field: 'numeroBoletim' },
                                                    { title: 'Situação Análise', field: 'situacaoAnalise' },
                                                    { title: 'Data Vistoria', field: 'dataVistoria', render: (rowData) => formateDate(rowData.dataVistoria) },
                                                    { title: 'Última Atualização', render: (rowData) => formateDateandTime(rowData.dataUltimaAtualizacao) },
                                                    { title: 'Contratada', field: 'concessionaria' },
                                                    { title: 'Regional', field: 'regional' },
                                                    { title: 'Agente Fiscalizador', field: 'usuarioFiscal_Nome' },
                                                    { title: 'Formulário', field: 'formularioVistoria_Identificacao' },
                                                ]}
                                                data={list_table}
                                                isLoading={false}
                                                options={{
                                                    ...table_style,
                                                    filtering: false,
                                                    exportButton: true
                                                }}
                                                actions={[
                                                    {
                                                        icon: 'search',
                                                        tooltip: 'Visualizar Registro',
                                                        onClick: (event, rowData) => handleView(rowData)
                                                    }
                                                ]}
                                                localization={table_translate}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-4 text-center">
                                        <Col lg="4" md="4" sm="4">
                                            <i className="fas fa-circle text-success"></i>
                                            <strong className="pl-2">Pendente</strong>
                                        </Col>
                                        <Col lg="4" md="4" sm="4">
                                            <i className="fas fa-circle text-warning"></i>
                                            <strong className="pl-2">Urgente</strong>
                                        </Col>
                                        <Col lg="4" md="4" sm="4">
                                            <i className="fas fa-circle text-danger"></i>
                                            <strong className="pl-2">Crítico</strong>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {showDetail &&
                <VistoriaFicha
                    boletimVistoria={rowView}
                    handleReturn={handleReturn}
                    setshowLoading={setshowLoading}
                />
            }
        </>

    );
}